import { ArrowRight } from 'lucide-react';
import { Reveal } from '@/components/ui/reveal';
import { CtaButton } from './cta-button';

const STEPS = [
  {
    title: 'Sign up & pin your plot',
    detail: 'Takes 2 minutes. Provide your Property boundary on the Map, leave us instructions.',
  },
  {
    title: 'A vetted inspector visits on schedule',
    // TODO(#201): confirm with ops that ID/background verification and
    // GPS-tagged, timestamped capture are fully implemented end-to-end
    // before publishing this copy. Flag to product if any part is aspirational.
    detail:
      'Every inspector is locally based, ID-verified, and background-checked before they walk your boundary. Each photo and video is GPS-tagged.',
  },
  {
    title: 'You get the full report',
    detail:
      'Photos, video, and a 6-point condition checklist covering encroachment, waste dumping, drainage, and vegetation.',
  },
];

/**
 * Split Studio module · direction flips to proof-left / text-right.
 * F4 step sequence · numbering 1.0/2.0/3.0 · vertical stack · no connector.
 */
export function HowItWorks() {
  return (
    <section id="how-it-works" className="scroll-mt-8 border-y border-line-strong bg-card/60">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-20 md:py-28">
        <div className="grid gap-10 sm:gap-12 lg:grid-cols-[minmax(0,7fr)_minmax(0,4fr)] lg:gap-20">
          <Reveal className="order-first lg:order-last lg:sticky lg:top-12 lg:self-start">
            <h2 className="font-display text-3xl font-medium leading-tight tracking-tight text-foreground [overflow-wrap:anywhere] md:text-4xl">
              From sign-up to your first report, without leaving home.
            </h2>
            <div className="mt-8">
              <CtaButton
                location="how_it_works"
                variant="ink"
                depth="3d"
                className="w-full sm:w-auto"
              >
                Start in 2 Minutes
                <ArrowRight className="size-4" />
              </CtaButton>
            </div>
          </Reveal>

          <ol className="border-t border-line-strong lg:order-first">
            {STEPS.map(({ title, detail }, idx) => (
              <li key={title} className="border-b border-border">
                <Reveal delay={idx * 0.08} className="grid gap-x-6 py-8 sm:grid-cols-[4rem_1fr]">
                  <p className="font-display text-lg text-ring">{`${idx + 1}`}</p>
                  <div className="mt-2 sm:mt-0">
                    <h3 className="font-display text-xl font-medium text-foreground">{title}</h3>
                    <p className="mt-3 max-w-prose leading-relaxed text-foreground/70">{detail}</p>
                  </div>
                </Reveal>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
